module.exports = __webpack_public_path__ + "static/media/icon-menu-toggle.ad89aeb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-menu-toggle.svg
// module id = 1262
// module chunks = 19